import React, { useState } from 'react';
import '../Contact/contact.css';
import Input from '../Contact/Input';
import standingGirl from '../images/standingGirl.png';

const Contact = () => {
	
	return (
		<div
			
			id="Contact">
			<Input />
			{/* <div
				className="image-wrapper"
				>
				<img
					className="delivering-message-image"
					src={standingGirl}
					alt=""
					width="390"
					height="390"
					
				/>
			</div> */}
		</div>
	);
};

export default Contact;
